import React from "react";
import "./styles.scss";

const AccountVerify = ({ data, onClick }) => {
  return (
    <>
      <div className="cw__verify-wrapper">
        ❗{data.title}
        <div className="cwvw-button" onClick={onClick}>
          {data.button}
        </div>
      </div>
    </>
  );
};
export default AccountVerify;
